import * as types from "./actionTypes";

export const saveYoutubePlanRequest = (payload, callback) => ({
  type: types.SAVE_YOUTUBE_PLAN_REQUEST,
  payload,
  callback,
});

export const saveYoutubePlanSuccess = (payload) => ({
  type: types.SAVE_YOUTUBE_PLAN_SUCCESS,
  payload,
});

export const saveYoutubePlanFailure = (error) => ({
  type: types.SAVE_YOUTUBE_PLAN_FAILURE,
  error,
});

export const fetchUserJobsRequest = (payload, callback) => ({
  type: types.FETCH_USER_JOBS_REQUEST,
  payload,
  callback,
});

export const fetchUserJobsSuccess = (payload) => ({
  type: types.FETCH_USER_JOBS_SUCCESS,
  payload,
});

export const fetchUserJobsFailure = (error) => ({
  type: types.FETCH_USER_JOBS_FAILURE,
  error,
});
